export const DESKTOP = 'DESKTOP';
export const MOBILE = 'MOBILE';


// WEBPACK FOOTER //
// ./src/actions/mobile.js